import React, { Component, useContext, useEffect, useState } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, SubmitBtn, formatDate } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import Select from 'react-select';
import { currentDateAndTime } from '../../Constants/constants';
import ToggleSwitch from '../../Components/ToggleSwitch';
import { NoRecords } from '../../Components/Shimmer';
import { decodeData } from '../../Constants/constants';
import { useLocation } from 'react-router-dom';

const HeaderMaster = () => {
    const { apiURL, apiHeaderFile, apiHeaderJSON ,permissions,setPermissions} = useContext(ConfigContext);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const encodedData = queryParams.get("abs");
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
    
    const [rows, setRows] = useState([]);
    const [parentHeaderRows, setParentHeaderRows] = useState([]);
    const [formData, setFormData] = useState({
        headerName: "",
        headerPath: "",
        headerStatus: "0",
        parentId: null,
    });
    const [errors, setErrors] = useState({});

    const getList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Employees/GetHeaderList`, {
            params: {
            }, headers
        }).then((response) => {
            let data = response.data;
            console.log(data);
            if (response.data.success === true) {
                let rows = data?.header_list?.map((val) => {
                    return { value: val?.header_id, label: val?.header_name }
                });
                setParentHeaderRows(rows);
                setRows(data?.header_list);
            } else {
                console.error("Error fetching list");
            }
        }).catch(function (error) {
            console.log("error", error);
        });
    }

    useEffect(() => {
        getList();
    }, []);

    const handleChange = (name, value) => {
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: "" });
    }

    const handleToggleSwitch = () => {
        setFormData((prevData) => ({
            ...prevData,
            headerStatus: formData?.headerStatus == "1" ? "0" : "1",
        }));
    };

    const getInfo = (id) => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Employees/GetHeaderInfo?id=${id}`,
            { headers })
            .then((response) => {
                const { success, result } = response.data;
                console.log(response?.data);
                if (success === true) {
                    setFormData({
                        header_id: result[0]?.header_id,
                        headerName: result[0]?.header_name,
                        headerPath: result[0]?.header_path,
                        headerStatus: result[0]?.header_status || "0",
                        parentId: result[0]?.parent_id,
                    });

                } else {

                }
            });
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        // const errors = validateForm();
        // console.log("errors 1", errors);
        // if (Object.keys(errors).length > 0) {
        //     setErrors(errors);
        //     return;
        // }
        let data = {
            header_id: formData?.header_id || null,
            headerName: formData?.headerName,
            headerPath: formData?.headerPath,
            headerStatus: formData?.headerStatus || "0",
            parentId: formData?.parentId,
            date: currentDateAndTime(),

        }

        const headers = apiHeaderJSON;
        //
        console.log("handleSubmit ~ form Data =======>>>", formData);
        axios
            .post(`${apiURL}Employees/CreateHeader`, data, {
                headers,
            })
            .then((response) => {
                const { success } = response.data;
                console.log("handleSubmit ~ response =======>>>", response);
                if (success === true) {

                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true,  // Show OK button
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // Optional: You can perform any action here after OK is clicked
                            setFormData({
                                headerName: "",
                                headerPath: "",
                                headerStatus: "0",
                                parentId: "",
                            });
                            getList(); // Call your function after the alert is closed
                        }
                    });



                } else {
                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true,  // Show OK button
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // Optional: You can perform any action here after OK is clicked
                            // Call your function after the alert is closed
                        }
                    });
                }
            });

    }

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <br />
                    <PageTitle title={`Header Master`} primary={`Home`} />
                    <div className="row">
                        <div className="col-md-5">
                            <div className="card">
                                <div className="card-header align-items-center d-flex">
                                    <h4 className="card-title mb-0 flex-grow-1">Header</h4>
                                </div>
                                <div className="card-body">
                                    <div className="row gy-4">
                                        <div className="col-md-12">
                                            <form onSubmit={handleSubmit} className="row">
                                                <div className="col-md-6 mt-3">
                                                    <label htmlFor="headerName" className="form-label">Header Name</label>
                                                    <input
                                                        type="text"
                                                        className={`form-control ${errors.headerName ? 'is-invalid' : ''}`}
                                                        id="headerName"
                                                        name="headerName"
                                                        value={formData?.headerName}
                                                        onChange={(e) => handleChange("headerName", e.target.value)}
                                                        placeholder="Enter Header Name"
                                                    />
                                                    {errors.headerName && <div className="text-danger">{errors.headerName}</div>}
                                                </div>
                                                <div className="col-md-6 mt-3">
                                                    <label htmlFor="headerPath" className="form-label">Header Path</label>
                                                    <input
                                                        type="text"
                                                        className={`form-control ${errors.headerPath ? 'is-invalid' : ''}`}
                                                        id="headerPath"
                                                        name="headerPath"
                                                        value={formData?.headerPath}
                                                        onChange={(e) => handleChange("headerPath", e.target.value)}
                                                        placeholder="Enter Header Name"
                                                    />
                                                    {errors.headerPath && <div className="text-danger">{errors.headerPath}</div>}
                                                </div>
                                                <div className="col-md-6 mt-3 mb-3">
                                                    <label>Select Parent Header</label>
                                                    <Select
                                                        onChange={(selectedOption) => setFormData({ ...formData, parentId: selectedOption?.value })}
                                                        placeholder={`Select Parent`}
                                                        options={parentHeaderRows}
                                                        value={formData?.parentId ? parentHeaderRows.find(option => option.value === formData?.parentId): null}
                                                    />
                                                    {errors.parentId && <div className="text-danger">{errors.parentId}</div>}
                                                </div>
                                                <div className="col-md-6 mt-3">
                                                    <div>
                                                        <label>Do you want to show this header?</label>
                                                    </div>
                                                    <div className="">
                                                        <div className=' d-flex align-items-center gap-2'>
                                                            <ToggleSwitch isActive={formData?.headerStatus == '1'} isExtFunc={true} onToggle={handleToggleSwitch} />
                                                            {/* <span style={{ fontSize:"1.1rem", fontWeight:"600"}} className=' pb-2'>{formData?.lockAttendanceAndLeave === 1 || formData?.lockAttendanceAndLeave === "1"? "On":"Off"}</span> */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                    <SubmitBtn text={ formData?.header_id? "Update" : `Save`} type={`primary`} icon={`ri-save-line`} />
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className='card'>
                                <div  style={{ "maxHeight": "65vh", "overflowY": "auto" }} className="  col-md-12">
                                    <table className={`position-relative table table-bordered table-stripped `}>
                                        <thead className='table-light sticky-top z-1'>
                                            <tr>
                                                <th>Header Name</th>
                                                <th>Header Path</th>
                                                <th>Parent Name</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        {rows?.length === 0 ?
                                            <tbody>
                                                <tr>
                                                    <td colSpan={4}>
                                                        <NoRecords />
                                                    </td>
                                                </tr>
                                            </tbody> :
                                            <tbody>
                                                {
                                                    rows?.map((row) => {
                                                        return <tr key={row.header_id}>
                                                            <td>{row.header_name}</td>
                                                            <td>{row.header_path || "--"}</td>
                                                            <td>{row.parent_header_name || "--"}</td>
                                                            <td>
                                                                <ToggleSwitch isActive={row?.header_status == '1'} isExtFunc={true} onToggle={() => { }} />
                                                            </td>
                                                            <td className='d-flex justify-content-around'>
                                                                <button type='button' onClick={() => { setFormData({...formData, header_id: row?.header_id}); getInfo(row?.header_id)}} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>
                                                                {/* <button onClick={() => this.handleDelete(row.leave_type_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button> */}
                                                                {/* <button type='button' onClick={() => this.setState({ leave_type_id: row.leave_type_id }, (prevState) => this.GetInfo())} className="btn-icon btn btn-sm btn-outline-info" data-bs-toggle="modal" data-bs-target="#myModal"> <i className="mdi mdi-view-list-outline fs-4"></i> </button> */}
                                                            </td>
                                                        </tr>
                                                    })
                                                }
                                            </tbody>
                                        }

                                    </table>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HeaderMaster;
